import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { getSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import { autoEuropeListData, autoEuropeIsLoading } from "Pages/AutoEuropeTool/Page/@signals"

export default function useAutoEuropeTable() {
	const { showToast } = useToast()

	const getTableData = useCallback(() => {
		batch(() => {
			autoEuropeIsLoading.value = true
			autoEuropeListData.value = []
		})
		getSubmit(`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/list`)
			.then(data => {
				batch(() => {
					autoEuropeListData.value = data
					autoEuropeIsLoading.value = false
				})
			})
			.catch(() => {
				autoEuropeIsLoading.value = false
				showToast.error("Error loading AutoEurope pricing tools")
			})
	}, [])

	return { getTableData }
}